/**
 * ANI Swap Modal Header Component
 *
 * Displays the input/output currencies and amounts for ANI swaps
 * in the confirmation modal.
 */

import { ArrowDown } from 'react-feather'
import styled, { useTheme } from 'styled-components/macro'
import { AniSwapInfo } from 'types/ani'

import { AutoColumn } from '../Column'
import CurrencyLogo from '../Logo/CurrencyLogo'
import { RowBetween, RowFixed } from '../Row'

const AniSwapContainer = styled(AutoColumn)`
  padding: 12px 16px;
`

const AniTokenRow = styled(RowBetween)`
  padding: 12px;
  background: ${({ theme }) => theme.backgroundModule};
  border-radius: 12px;
`

const AniArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px 0;
`

const AniTokenAmount = styled.span`
  font-size: 24px;
  font-weight: 500;
`

const AniTokenSymbol = styled.span`
  font-size: 20px;
  color: ${({ theme }) => theme.textSecondary};
  margin-left: 8px;
`

interface AniSwapModalHeaderProps {
  aniSwapInfo: AniSwapInfo
}

export default function AniSwapModalHeader({ aniSwapInfo }: AniSwapModalHeaderProps) {
  const theme = useTheme()

  return (
    <AniSwapContainer gap="sm">
      <AniTokenRow>
        <RowFixed>
          <CurrencyLogo currency={aniSwapInfo.inputCurrency} size="24px" style={{ marginRight: '12px' }} />
          <AniTokenAmount>{aniSwapInfo.inputAmount.toSignificant(6)}</AniTokenAmount>
          <AniTokenSymbol>{aniSwapInfo.inputCurrency.symbol}</AniTokenSymbol>
        </RowFixed>
      </AniTokenRow>
      <AniArrowWrapper>
        <ArrowDown size={20} color={theme.textSecondary} />
      </AniArrowWrapper>
      <AniTokenRow>
        <RowFixed>
          <CurrencyLogo currency={aniSwapInfo.outputCurrency} size="24px" style={{ marginRight: '12px' }} />
          <AniTokenAmount>{aniSwapInfo.outputAmount.toSignificant(6)}</AniTokenAmount>
          <AniTokenSymbol>{aniSwapInfo.outputCurrency.symbol}</AniTokenSymbol>
        </RowFixed>
      </AniTokenRow>
    </AniSwapContainer>
  )
}
